import { render } from "./link-navbar.vue?vue&type=template&id=255f930c"
import script from "./link-navbar.vue?vue&type=script&lang=js"
export * from "./link-navbar.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miqrositio/miqrositio_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__